import React from 'react';
import { withRouter } from 'react-router-dom';

import CriticalError from '~/routes/CriticalError';


// Top-level boundary around the routed app (inside the Router, around routes/Root): an
// unexpected render error shows the CriticalError page ("Please reload the page...") instead
// of unmounting everything, and is reported to LogRocket/Sentry with the last action and
// state, like any other exception (console.reportException, utils/bootstrap/setup-errors).
// React doesn't pass errors it caught in a boundary to window.onerror in production builds.
// Navigating elsewhere (the navbar's home link, the browser's back button) clears the error
// and renders the new route.
class ErrorBoundary extends React.Component {

  state = {
    error: null,
  };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.reportException(error, {
      from: 'components/ErrorBoundary',
      componentStack: info?.componentStack,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.state.error != null && prevProps.location !== this.props.location) {
      this.setState({ error: null });
    }
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    return error != null ? <CriticalError /> : children;
  }

}


export default withRouter(ErrorBoundary);
